import * as Icons from "@mui/icons-material"

export default [
    {
        link: "/",
        name: "Home",
        icon: Icons.Home
    },

    {
        link: "/skills",
        name: "Skills",
        icon: Icons.DynamicFeed
    },

    {
        link: "/formations",
        name: "Formations",
        icon: Icons.ImportContacts
    },

    {
        link: "/social-networks",
        name: "Social Networks",
        icon: Icons.ConnectWithoutContact
    },

    {
        link: "/contacts",
        name: "Contacts",
        icon: Icons.ContactPhone
    },
]
